<template>
  <div>
    <v-container class="ml-10">
      <p class="display-1 mt-7">정품 QR 코드 인쇄 설정</p>
      <p class="mb-0 subtitle-1 font-weight-light">
        정품 인증 인쇄시 QR코드를 사용 할 수 있습니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        고객은 상품에 부착된 QR코드를 스마트폰(네이버,카카오톡등 스캔 기능)을 통해 스캔하여
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        쇼핑몰로 바로 접속이 가능하게 해주므로 더욱 쉽게 인증을 받을 수 있습니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        설정한 인쇄 설정을 통해 [정품 인증 코드 관리] 메뉴에서 인쇄 기능을 사용 할 수 있습니다.
      </p>

      <PrintqrSetting></PrintqrSetting>
    </v-container>
  </div>
</template>

<script>
import PrintqrSetting from "@/components/shoplus_authservice/printqr/PrintqrSetting.vue";

export default {
  components: {
    PrintqrSetting,
  },
};
</script>
